<template>
<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24 43.9995C35.0457 43.9995 44 35.0452 44 23.9995C44 12.9538 35.0457 3.99951 24 3.99951C12.9543 3.99951 4 12.9538 4 23.9995C4 35.0452 12.9543 43.9995 24 43.9995Z" stroke="#CAEDE7" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M32.25 19.4995L21.4219 29.9995L16.5 25.2268" stroke="#33BDA3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
</template>

<script>
export default {

}
</script>

<style>

</style>